<div class="dealer-info-compact">
  <ul class="mb-0 {{language}}">
    <li class="gb-body2 mb-0 heavy">{{dealer.name | uppercase}}</li>
    <li class="gb-body3 mb-0">{{dealer.street}}</li>
    <li class="gb-body3 mb-0">{{dealer.city}}, {{dealer.state}}</li>
    <li class="mb-4 gb-body3">{{dealer.zipCode}}</li>
    <div class="row mb-4">
        <div class="col-12 col-lg-6 mb-2 mb-lg-0">
        <div class="gb-body2 heavy">
            <p for="dealerSalesPhone" class="mb-0" [translate]="'preferredDealer_dealer_salesPhoneLabel_noColon'"></p>
        </div>
        <div class="gb-body2">
            <a id="dealerSalesPhone" [href]="'tel:'+dealer.salesPhone"
                [evar33]="'vehicle profile:preferred dealer:link:dial sales'"
                [prop10]="'vehicle profile:preferred dealer:link:dial sales'"
                [prop15]="'dial sales'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [trackLink]="'compactDealer:dialSales'">{{dealer.salesPhone}}</a>
        </div>
        </div>
        <div class=" col-12 col-lg-6">
        <div class="gb-body2 heavy">
            <p for="dealerServicePhone" class="mb-0" [translate]="'preferredDealer_dealer_servicePhoneLabel_noColon'"></p>
        </div>
        <div class="gb-body2">
            <p class="mb-0">
            <a id="dealerServicePhone" class="my-0 py-0" [href]="'tel:'+dealer.servicePhone"
                [evar33]="'vehicle profile:preferred dealer:link:dial service'"
                [prop10]="'vehicle profile:preferred dealer:link:dial service'"
                [prop15]="'dial service'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [trackLink]="'compactDealer:dialService'">{{dealer.servicePhone}}</a>
            </p>
        </div>    
        </div>
    </div> 
    <li class="gb-body2 mb-2" *ngIf="dealer.dealerWebSite">
        <a class="py-0"
            target="_blank"
            [href]="dealer.dealerWebSite"
            aria-haspopup="dialog"
            aria-expanded="false"
            [evar33]="'vehicle profile:preferred dealer:link:dealer website'"
            [prop10]="'vehicle profile:preferred dealer:link:dealer website'"
            [prop15]="'dealer website'"
            [trackDelay]="'true'"
            [trackType]="'o'"
            [trackLink]="'compactDealer:dealerWebSite'">
            <span class="icon-ui-newwindow" [attr.aria-label]="[dealer.name, ('aoda_open_new_window_aria_label' | translate)].join(' ')"></span>&nbsp;
            <span [translate]="'preferredDealer_dealerWebsite'"></span>
        </a>
    </li>
    <li class="gb-body2 mb-2">
        <a  class="py-0" tabindex="0"
            (click)="openGoogleMaps()"
            (keyup.enter)="openGoogleMaps()"
            [evar33]="'vehicle profile:preferred dealer:link:driving directions'"
            [prop10]="'vehicle profile:preferred dealer:link:driving directions'"
            [prop15]="'driving directions'"
            [trackDelay]="'true'"
            [trackType]="'o'"
            [trackLink]="'compactDealer:drivingDirections'">
            <span [translate]="'preferredDealer_directions_getDirectionsBtn'"></span>
        </a>
    </li>
  </ul>
</div>  